import Sidebar from "../components/Sidebar";
import GameCard from "../components/Card/GameCard";
import FilterCheckBoxTable from "../components/Table/FilterCheckBoxTable";
import CartSidebar from "../components/CartSidebar";
import React, {useEffect, useState} from "react";
import neverLandGameData from "../utils/NeverLandGameData";
import SelectedGameTable from "../components/Table/SelectedGameTable";
import loadDummyData, {mainConfig} from "../utils/_dummyData";
import {accountInfo} from "../constants/constants";
import neverLandUtils from "../utils/NeverLandUtils";
import GameCardLargeFont from "../components/Card/GameCardLargeFont";
import MagnifierModeGameCard from "../components/Card/MagnifierModeGameCard";
import TextToOrderModal from "../components/Modal/TextToOrderModal";
import GameAnalysisModal from "../components/Modal/GameAnalysisModal";
import Footer from "../components/Footer";
import {RiMailSendFill} from "react-icons/ri";
import {ModalHandler, OpenModalHandle} from "../components/Modal/Generic/ModalHandler";
import {MAIN_PAGE_TEMP} from "../constants/page_constants";

const MainPage = () => {
  const [textToOrder, setTextToOrder] = useState(null);
  const [mouseOverData, setMouseOverData] = useState(null); // 돋보기 모드일때
  const [refreshDate, setRefreshDate] = useState(new Date());
  const [showCartSidebar, setShowCartSidebar] = useState(false);
  const [showGameAnalysisModal, setShowGameAnalysisModal] = useState(false);  // 경기분석 모달 보이기 여부
  const [gameId, setGameId] = useState(null);
  const [analysisType, setAnalysisType] = useState(null); // 경기 분석
  const [showNoticeModal, setShowNoticeModal] = useState(true); // FIXME: 어플승인용 임시
  const local_nice_result = neverLandUtils.commons.load('nice_auth') ?? null;
  const OpenModal = OpenModalHandle.create();

  useEffect(() => {
    // 로컬 스토리지 나이스 인증 정보 가져오기
    if (local_nice_result) {
      // 미성년자 가입 불가.
      if (local_nice_result.niceUserInfo.adult === false) {
        OpenModal.openWarningModal('인증 실패', '19세 미만은 이용할 수 없습니다.');
        return;
      }
      if (local_nice_result.isCertify === false) {
        // 인증 실패
        OpenModal.openWarningModal('인증 실패', local_nice_result.message);
      }
      if (local_nice_result.isCertify === true) {
        // 인증 성공
        OpenModal.openConfirmModal('인증 성공', '본인 인증에 성공하였습니다.');
      }
      // 로컬스토리지 나이스 인증 정보 비우기
      neverLandUtils.commons.remove('nice_auth');
    }
  }, []);


  const updateUI = () => {
    if (mouseOverData) {
      setMouseOverData(null);
      return;
    }
    setRefreshDate(new Date());
  }
  const handleOnChanged = () => {
    updateUI();
  };

  let prevScreenSize = "unknown";

  function handleResize() {
    const width = window.innerWidth;
    let currentScreenSize;

    if (width >= 1024) {
      currentScreenSize = "large";
    } else if (width >= 768) {
      currentScreenSize = "mid";
    } else {
      currentScreenSize = "small";
    }
    if (prevScreenSize === currentScreenSize) {
      return;
    }
    if (prevScreenSize === "small" && currentScreenSize !== "small") {
      _setShowCartSidebar(false);
    }
    prevScreenSize = currentScreenSize;
  }

  useEffect(() => {
    neverLandGameData.clearSelection();
    neverLandGameData.addOnChangedHandler(handleOnChanged);
    loadDummyData();

    window.addEventListener('resize', handleResize);

    return () => {
      neverLandGameData.removeOnChangedHandler(handleOnChanged);
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  const today = new Date();
  const thisYear = today.getFullYear();

  let _selected_game_count = neverLandGameData.selectedAllotData ? neverLandGameData.selectedAllotData.length : "-";
  let _selected_ticket_count = neverLandGameData.ticketData ? neverLandGameData.ticketData.length : "-";

  if (!showCartSidebar) {
    if (mainConfig._powered_refresh_folder) {
      mainConfig._powered_refresh_folder = false;
      neverLandGameData.refreshFolder(neverLandGameData.currentFolderNumber());
    }
  }
  const handleReadClipboard = async () => {
    // 클립보드에서 텍스트를 읽고 setTextToOrder 넘겨주기
    let _text = "";
    try {
      const text = await navigator.clipboard.readText();
      if (text) {
        _text = text.trim();
      }
    } catch (err) {
      setTextToOrder("//" + neverLandUtils.utils.getDisplayTimeText(new Date()) + "\n");
    }
    if (_text.length === 0) {
      setTextToOrder("//" + neverLandUtils.utils.getDisplayTimeText(new Date()) + "\n");
      return;
    }
    if (_text.includes("승") || _text.includes("무") || _text.includes("패") || _text.includes("언더") || _text.includes("오버")
        || _text.includes("win") || _text.includes("draw") || _text.includes("lose") || _text.includes("under") || _text.includes("over")) {
      setTextToOrder("//" + neverLandUtils.utils.getDisplayTimeText(new Date()) + "\n" + _text);
      return;
    }
    setTextToOrder("//" + neverLandUtils.utils.getDisplayTimeText(new Date()) + "\n");
  };

  const _setShowCartSidebar = (isShow) => {
    mainConfig._powered_refresh_folder = true;
    setShowCartSidebar(isShow);
  }

  return (
      <div className="w-full h-full bg-stone-100 flex flex-col relative mb-12 lg:mb-0">
        <ModalHandler path={MAIN_PAGE_TEMP} initModalHandle={OpenModal}/>
        {/*{showNoticeModal && <NoticeModal setShowNoticeModal={setShowNoticeModal}/>}*/}
        {/* 돋보기 모드 게임카드 */}
        {mouseOverData && <MagnifierModeGameCard mouseOverData={mouseOverData}/>}
        {/* 문자 의뢰 */}
        {textToOrder && <TextToOrderModal originText={textToOrder} refreshDate={refreshDate}/>}

        {/* 경기분석 모달 */}
        {showGameAnalysisModal && <GameAnalysisModal
            analysisType={analysisType}
            gameId={gameId}
            setGameId={setGameId}
            showGameAnalysisModal={showGameAnalysisModal}
            setShowGameAnalysisModal={setShowGameAnalysisModal}
        />}

        {/* 사이드바 영역 */}
        <Sidebar/>

        <main className="lg:pl-64 min-h-screen">
          <div
              className={neverLandUtils.classNames(neverLandGameData.getFilteredGameData().length > 0 ? "md:pr-104" : "")}>
            <div className="lg:min-h-[calc(100vh-10.05rem)]">
              {/* 게임정보 영역 */}
              {!showCartSidebar &&
                  <div>
                    <div className="px-4 sm:px-6 lg:px-8 py-3 lg:py-6">
                      <div className="md:px-2 flex flex-col justify-start mb-2">
                        {/*<div className="flex flex-row pb-2 items-center">*/}
                        {/*  <p className="text-lg md:text-2xl font-semibold cursor-pointer inline-block"*/}
                        {/*     onClick={() => neverLandGameData.loadGameDataList("main_page_click")}*/}
                        {/*  >*/}
                        {/*    {neverLandGameData.gameRound !== -1 ? "프로토 승부식 " + thisYear + "년 " + neverLandGameData.gameRound + "회차" : "프로토 승부식 | 정보를 가져오는 중..."}*/}
                        {/*  </p>*/}

                        {accountInfo.isStore() && // 문자의뢰 버튼
                            <div
                                className="w-24 flex flex-row bg-sky-700 text-white items-center px-1.5 md:px-3 py-0.5 rounded-md cursor-pointer whitespace-nowrap mb-2"
                                onClick={handleReadClipboard}
                            >
                              <RiMailSendFill className="h-6 w-auto mr-1"/>
                              <p>문자예측</p>
                            </div>
                        }
                        {/*</div>*/}

                        {/* 조회조건 테이블 */}
                        <FilterCheckBoxTable/>
                      </div>

                      {/* 선택경기 고정 테이블 */}
                      <SelectedGameTable/>
                      {/* 게임카드 */}
                      {accountInfo.getUserConfig().isOn('use_large_font', false) ?
                          // 큰 글씨 모드 게임카드
                          <GameCardLargeFont
                              setShowGameAnalysisModal={setShowGameAnalysisModal}
                              setMouseOverData={(data) => {
                                if (mouseOverData === null || mouseOverData.displayData !== data) setMouseOverData(data)
                              }}
                              setAnalysisType={setAnalysisType}
                              setGameId={setGameId}
                          />
                          :
                          // 기본 게임 카드
                          <GameCard
                              setShowGameAnalysisModal={setShowGameAnalysisModal}
                              setMouseOverData={(data) => {
                                if (mouseOverData === null || mouseOverData.displayData !== data) setMouseOverData(data)
                              }}
                              setAnalysisType={setAnalysisType}
                              setGameId={setGameId}
                          />
                      }
                    </div>


                    {/* 모바일버전 하단 */}
                    <button className="md:hidden sm:block fixed bottom-0 w-full"
                            onClick={() => setShowCartSidebar(true)}>
                      <div className="h-12 bg-red-700 flex flex-row justify-center items-center">
                        <p className="text-white font-semibold mr-3">배팅카트</p>
                        {/*<p className="text-white"> {_selected_game_count} 경기 ( {_selected_ticket_count} 조합 )</p>*/}
                      </div>
                    </button>
                  </div>
              }
              {/* 모바일버전 카트사이드바 */}
              {showCartSidebar &&
                  <div className="w-auto max-w-md px-8 py-6 lg:hidden overflow-y-auto">
                    <CartSidebar showCartSidebar={showCartSidebar} setShowCartSidebar={_setShowCartSidebar}/>
                  </div>
              }

            </div>
            <Footer/>
          </div>
        </main>

        {/* 카트사이드바 */}
        {neverLandGameData.getFilteredGameData().length > 0 &&
            <aside
                className="fixed inset-y-0 right-0 hidden w-full sm:w-104 overflow-y-auto border-l border-gray-200 px-0 py-6 sm:px-6 md:block">
              <CartSidebar showCartSidebar={showCartSidebar} setShowCartSidebar={_setShowCartSidebar}/>
            </aside>
        }
      </div>
  )
}
export default MainPage;